<template>
    <div class="position-relative">
        <div
            v-if="creatorVideo.message"
            class="video-message position-absolute text-center px-2 py-1 mb-0"
        >
            {{ creatorVideo.message }}
        </div>
        <video-player
            v-if="simplePlayer"
            :class="{ 'img-fluid': fluid }"
            :muted="isMuted"
            :controls="true"
            :autoplay="true"
            :loop="true"
            :creatorVideo="creatorVideo"
            :poster="creatorVideo.previewUrl"
            :mp4Url="creatorVideo.mp4Url"
            :webmUrl="creatorVideo.webmUrl"
        />
        <creator-video-js-player
            v-else
            :class="{ 'img-fluid': fluid }"
            :muted="isMuted"
            :controls="true"
            :autoplay="true"
            :loop="true"
            :creatorVideo="creatorVideo"
            :poster="creatorVideo.previewUrl"
            :mp4Url="creatorVideo.mp4Url"
            :webmUrl="creatorVideo.webmUrl"
        />
    </div>
</template>

<style scoped>
.video-message {
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    font-size: 0.8rem;
    line-height: 1.3;
    color: #fff;
    background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.55),
        rgba(0, 0, 0, 0)
    );
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
    pointer-events: none;
    padding-bottom: 1rem !important;
}
</style>

<script>
import { mapState } from "vuex";

import CreatorVideoJsPlayer from "@/components/creatorVideo/CreatorVideoJsPlayer";
import VideoPlayer from "@/components/utility/VideoPlayer";

export default {
    computed: {
        ...mapState("videoIndex", ["isMuted"]),
    },
    components: {
        CreatorVideoJsPlayer,
        VideoPlayer,
    },
    props: ["creatorVideo", "fluid", "simplePlayer"],
};
</script>
